import hyperdom from 'hyperdom'
import responsiveRender from '../../../responsiveRender.js'

export default class PassengersTabSection {
  constructor ({
    sectionComponents,
    sectionAttributes: {
      sectionName, title,
      message,
      optional = true,
      opened = false,
    },
  }) {
    this.sectionComponents = sectionComponents
    this.sectionName = sectionName
    this.title = title
    this.optional = optional
    this.message = message
    this.opened = opened
  }

  render () {
    return <div className={`${this.sectionName}-section`}>
      {responsiveRender('medium',
        () => this.renderSections({isMobile: true}),
        () => this.renderSections({isMobile: false})
      )}
    </div>
  }

  renderSections ({isMobile}) {
    if (isMobile) {
      this.opened = true
    }
    return <div className='passengers-section o-accent-box'>
      <div className='passengers-section__header'>
        <div className='passengers-section__header-container'>
          <div className='passengers-section__header-first-line'>
            {this.title ? <div className='passengers-section__header-title'>{this.title}</div> : undefined}
            {this.optional ? <span className={['passengers-section__header-optional']}>Optional</span> : undefined}
          </div>
          {this.message ? <div className='passengers-section__header-message'>{this.message}</div> : undefined}
        </div>
        <div className='passengers-section__toggle-button-wrapper'>
          <div className='passengers-section__toggle-button btn-secondary-outline'
            onclick={() => this.toggleSection()}
          >
            {this.opened ? 'Hide' : 'Add'}
          </div>
        </div>
      </div>
      <div className={['expandable-section', {'expandable-section--opened': this.opened}]}>
        {this.opened ? this.sectionComponents.map(section => section) : undefined}
      </div>
    </div>
  }

  toggleSection () {
    this.opened = !this.opened
  }
}
